import React from 'react';

const Form = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="75"
      height="75"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-12 -8 64 64"
    >
      <g fill="#F9BF35" fillRule="evenodd">
        <path
          d="M15.9594828 42.525H1.88534483V1.88534483H32.8422414V25.6422414c-.0324394.3572028.1398039.7020572.444869.8906877.3050651.1886306.6905417.1886306.9956068 0 .3050651-.1886305.4773084-.5334849.444869-.8906877V0H0v44.4103448h15.9594828c.4875868-.0442802.8609428-.453079.8609428-.9426724 0-.4895934-.373356-.8983921-.8609428-.9426724z"
          fill="#5c48d3"
        />
        <path
          d="M27.6672414 8.53448276H7.06034483c-.48758689.04428026-.86094281.453079-.86094281.94267241 0 .48959342.37335592.89839213.86094281.94267243H27.6672414c.4875869-.0442803.8609428-.45307901.8609428-.94267243 0-.48959341-.3733559-.89839215-.8609428-.94267241zM27.6672414 16.6112069H7.06034483c-.48758689.0442803-.86094281.453079-.86094281.9426724 0 .4895934.37335592.8983922.86094281.9426724H27.6672414c.4875869-.0442802.8609428-.453079.8609428-.9426724 0-.4895934-.3733559-.8983921-.8609428-.9426724zM27.6672414 24.6724138H7.06034483c-.48758689.0442803-.86094281.453079-.86094281.9426724 0 .4895934.37335592.8983922.86094281.9426724H27.6672414c.4875869-.0442802.8609428-.453079.8609428-.9426724 0-.4895934-.3733559-.8983921-.8609428-.9426724zM15.9594828 32.7258621H7.06034483c-.48758689.0442802-.86094281.453079-.86094281.9426724 0 .4895934.37335592.8983921.86094281.9426724h8.89913797c.4875868-.0442803.8609428-.453079.8609428-.9426724 0-.4895934-.373356-.8983922-.8609428-.9426724zM41.8189655 29.1181034c-.396404-.3405195-.9937635-.2953702-1.3344827.1008621L29.25 42.1836207l-6.4551724-6.2068966c-.3708873-.3627157-.9635955-.3627157-1.3344828 0-.178156.1763281-.2783982.41658-.2783982.6672414s.1002422.4909134.2783982.6672414l7.9215518 7.6112069 12.5146551-14.4698276c.3463297-.3901935.3116285-.9870534-.0775862-1.3344828z"
          fill="#5c48d3"
        />
      </g>
    </svg>
  );
};
export default Form;
